// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1Vnz5","head":"ProcedureTableInfo_head__1vyo0"};